/* ar-brown App (C) 2021 arbrown.co.jp All rights reserved.
 *******************************************************************************
 * Program ID:  Agent.js
 * $Revision:   Ver1.0
 * $Modtime:    $
 *******************************************************************************
 * Author      (作成／更新年月日、担当者)
 *  2021/08/01 Rayoo)li : 新規作成
 *
 * Summary Agent画面
 *
 * Instructions / Preconditions
 *  なし
 *
 *******************************************************************************
 */
import React, { useEffect, useState } from "react";
/*  GraphQL API Acess */
import API, { graphqlOperation } from "@aws-amplify/api";
import {
  customerByeMail,
  listArEndUsers,
  arEndUserByReceiptCode
} from "../graphql/queries";
/*  AWS標準設定 with Login Auth. */
import Amplify, { Auth } from "aws-amplify";
import awsconfig from "../aws-exports";
Amplify.configure(awsconfig);
import { Container, InputGroup,Row,Col} from "react-bootstrap";
import Grid from "@material-ui/core/Grid";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import CircularProgress from "@mui/material/CircularProgress";
import userAuth from "../components/userAuth";
import Button from "@material-ui/core/Button";
import Autocomplete from '@mui/material/Autocomplete';
import { makeStyles } from "@material-ui/core/styles";
import TextField from '@mui/material/TextField';
const useStyles = makeStyles((theme) => ({
  fixedTop: {
    position: "sticky",
    top: 0,
    boxShadow: "0 -1px 0 0 white,0 3px 0 0 #804F29,0 3px 0 0 transparent",
    backgroundColor: "white",
    zIndex: 9,
  },
  textlabel: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    background: "rgb(91,56,9)",
    border: "1px solid #707070",
    color: "white",
    fontWeight: "bold",
    fontSize: '14px',
    alignItems: 'center',
    justifyContent: 'center',
    width:'20%',
  },
  textFieldSearch:{
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    background: "transparent",
    border: "1px solid #707070",
    borderRadius: "6px",
    color: "black",
    width:'80%'
  },
}));
const customTotal = (from, to, size) => (
  <span
    style={{ marginLeft: "1em" }}
    className="react-bootstrap-table-pagination-total"
  >
    {size} の結果の {from} から {to} を表示しています
  </span>
);
const pageButtonRenderer = ({ page, onPageChange }) => {
  const handleClick = (e) => {
    e.preventDefault();
    onPageChange(page);
  };
  return (
    <button className="btn-secondary btn" type="button" key={page}>
      <li className="page-item">
        <a style={{ color: "white" }} href="#" onClick={handleClick}>
          {page}
        </a>
      </li>
    </button>
  );
};

const sizePerPageRenderer = ({
  options,
  currSizePerPage,
  onSizePerPageChange,
}) => (
    <div className="btn-group" role="group">
      {options.map((option) => (
        <button
          key={option.text}
          type="button"
          onClick={() => onSizePerPageChange(option.page)}
          className={`btn ${
            currSizePerPage === `${option.page}` ? "btn-warning" : "btn-light"
            }`}
        >
          {option.text}
        </button>
      ))}
    </div>
  );
const options = {
  paginationSize: 10,
  pageStartIndex: 1,
  showTotal: true,
  withFirstAndLast: true,
  firstPageText: "最初",
  prePageText: "戻る",
  nextPageText: "次へ",
  lastPageText: "最後",
  nextPageTitle: "最初のページ",
  prePageTitle: "プレページ",
  firstPageTitle: "次のページ",
  lastPageTitle: "最後のページ",
  paginationTotalRenderer: customTotal,
  sizePerPageRenderer: sizePerPageRenderer,
  pageButtonRenderer: pageButtonRenderer,
  disablePageTitle: true,
  sizePerPageList: [
    {
      text: "10",
      value: 10,
    },
    {
      text: "20",
      value: 20,
    },
    {
      text: "30",
      value: 30,
    },
  ],
};

export const EndUserList = () => {
  const [endUserList, setEndUserList] = useState([]);
  const [authDisplay, setauthDisplay] = useState(true);
  const [progress, setProgress] = useState(false);
  const classes = useStyles()
  const [OrderReceiptCodeList, setOrderReceiptCodeList] = useState([])
  const [EUARBmgmtCodeList, setEUARBmgmtCodeList] = useState([])
  const [searchValue, setSearchValue] = useState({
    OrderRecipientCode: "",
    EndUserCode: "",
      })
  const TextOrderReceiptCodeChange = (e, value) => {
        setSearchValue({ ...searchValue, OrderRecipientCode: value ? value.split(":")[0] : "" })
    }
  const TextEUARBmgmtCodeChange = (e, value) => {
      setSearchValue({ ...searchValue, EndUserCode: value ? value.split(":")[0] : "" })
  }
  const signOut = async () => {
      await Auth.signOut();
      try {
          await Auth.signOut();
      } catch (error) {
          console.log("error signing out: ", error);
      }
      document.location.reload();
  };
  const getTypePriority = (str) => {
    if (!str || str.trim() === "") return 99;
    const firstChar = str[0];
    if (/^[0-9]/.test(firstChar)) return 1;
    if (/^[a-zA-Z]/.test(firstChar)) return 2;
    if (/^[\u30A0-\u30FF]/.test(firstChar)) return 3;
    if (/^[\u3040-\u309F\u4E00-\u9FFF]/.test(firstChar)) return 4;
    return 5;
  };
  const sortByOrderRecipientName = (a, b)=> {
  const nameA = a.OrderRecipientName || "";
  const nameB = b.OrderRecipientName || "";
  const priorityA = getTypePriority(nameA);
  const priorityB = getTypePriority(nameB);
  if (priorityA !== priorityB) {
    return priorityA - priorityB;
  }
  return nameA.localeCompare(nameB, 'ja', { sensitivity: 'base' });
  }
  const sortByName1 = (a, b)=> {
    const nameA = a.Name1 || "";
  const nameB = b.Name1 || "";
  const priorityA = getTypePriority(nameA);
  const priorityB = getTypePriority(nameB);
  if (priorityA !== priorityB) {
    return priorityA - priorityB;
  }
  return nameA.localeCompare(nameB, 'ja', { sensitivity: 'base' });
  }
  const multiSort = (arr, ...sortFuncs)=> {
    return arr.sort((a, b) => {
      for (const func of sortFuncs) {
        const result = func(a, b);
        if (result !== 0) {
          return result;
        }
      }
      return 0;
    });
  }
  async function searchData() {
    let dataAll = [];
    const userAuths = await userAuth();
      try{
        if (userAuths === "1") {
          setauthDisplay(true);
          const user = await Auth.currentUserInfo();
          const agencyPriceGroup = await API.graphql(
            graphqlOperation(customerByeMail, {
              Agency_Email: user.attributes.email,
            })
          );
          const agentinfo = agencyPriceGroup.data.customerByeMail["items"];
          let agencyId = "";
          if (agentinfo.length > 0) {
            agencyId = agentinfo[0].Agency_id;
          }
          const EndUseList = await API.graphql(
            graphqlOperation(arEndUserByReceiptCode, {
              RecipientCode: agencyId,
            })
          );
          let list = EndUseList.data.ArEndUsersByOrderRecipientCode.items;
          dataAll = list.filter((item, index, self) =>
            index === self.findIndex(obj => obj.EndUserCode === item.EndUserCode)
            );
        } else {
          setauthDisplay(false);
      const EndUseList = await API.graphql(
        graphqlOperation(listArEndUsers, { limit: 10000 })
      );
      if (EndUseList.data.listArEndUsers !== null) {
        dataAll = EndUseList.data.listArEndUsers.items;
        let nextToken = EndUseList.data.listArEndUsers.nextToken;
        while (nextToken !== null) {
          let InvDataSec = await API.graphql(
            graphqlOperation(listArEndUsers, {
              limit: 10000,
              nextToken: nextToken,
                })
              );
          if (InvDataSec.data.listArEndUsers !== null) {
            nextToken = InvDataSec.data.listArEndUsers.nextToken;
            for (
              let i = 0;
              i < InvDataSec.data.listArEndUsers.items.length;
              i++
            ) {
              dataAll.push(InvDataSec.data.listArEndUsers.items[i]);
            }
          }
        }
      }
    }
      } catch (err) {
        console.log(err);
      }
    return dataAll
  }
  const searchBtn = async () => {
    setProgress(true)
    let arr = [];
    let dataAll = []
    let obj = {}
    try {
      dataAll = await searchData()
      obj = searchValue;
    dataAll.forEach(item => {
      let flag = true
      if (Object.keys(obj).length !== 0) {
        for (let name in obj) {
          if (obj[name] !== "") {
            if (item[name]) {
              if (!(item[name]).includes(obj[name])) {
                flag = false;
                break;
              }
            } else {
              flag = false
              break;
            }
          }
        }
      }
      if (flag === true) {
        arr.push(item)
      }
    })
    if(authDisplay){
      arr = multiSort(arr,sortByName1);
    }else{
      arr = multiSort(arr,sortByOrderRecipientName,sortByName1);
    }
    } catch (error) {
        if (error.message === 'No current user') {
            //ユーザープールに障害が発生した場合
            console.log('User pool is invalid.Please reauthenticate.');
            //ログイン画面に戻る
            signOut();
        } else {
            //他のエラーを処理する
            console.log('An error occurred:', error);
        }
    }
    setEndUserList(arr)
    setProgress(false)
}
const searchClear = async()=>{
  setProgress(true)
  let arr = [];
  try {
      arr = await searchData()
      if(authDisplay){
        arr = multiSort(arr,sortByName1);
      }else{
        arr = multiSort(arr,sortByOrderRecipientName,sortByName1);
      }
    } catch (error) {
      if (error.message === 'No current user') {
          //ユーザープールに障害が発生した場合
          console.log('User pool is invalid.Please reauthenticate.');
          //ログイン画面に戻る
          signOut();
      } else {
          //他のエラーを処理する
          console.log('An error occurred:', error);
      }
  }
  setSearchValue({OrderRecipientCode: "",EndUserCode: "",})
  setEndUserList(arr)
  setProgress(false)
}
const [scrollTableWidth,setscrollTableWidth] = useState('101%')
  function calculateZoomLevel() {
    const screenWidth = window.screen.width;
    const screenHeight = window.screen.height;
    const windowWidth = window.innerWidth;
    const windowHeight = window.innerHeight;
    const zoomLevel = ((windowWidth / screenWidth) + (windowHeight / screenHeight)) / 2;
    return Math.round(zoomLevel * 100);
  }
  useEffect(() => {
    let lastZoomLevel = calculateZoomLevel();
    async function getEndUserList() {
      let EndUserInfoLIst = [];
      setProgress(true);
      const userAuths = await userAuth();
      try{
        if (userAuths === "1") {
          setauthDisplay(true);
          const user = await Auth.currentUserInfo();
          const agencyPriceGroup = await API.graphql(
            graphqlOperation(customerByeMail, {
              Agency_Email: user.attributes.email,
            })
          );
          const agentinfo = agencyPriceGroup.data.customerByeMail["items"];
          let agencyId = "";
          if (agentinfo.length > 0) {
            agencyId = agentinfo[0].Agency_id;
          }
          const EndUseList = await API.graphql(
            graphqlOperation(arEndUserByReceiptCode, {
              RecipientCode: agencyId,
            })
          );
          let list = EndUseList.data.ArEndUsersByOrderRecipientCode.items;
          EndUserInfoLIst = list.filter((item, index, self) =>
            index === self.findIndex(obj => obj.EndUserCode === item.EndUserCode)
            );
        } else {
          setauthDisplay(false);
      const EndUseList = await API.graphql(
        graphqlOperation(listArEndUsers, { limit: 10000 })
      );
      if (EndUseList.data.listArEndUsers !== null) {
        EndUserInfoLIst = EndUseList.data.listArEndUsers.items;
        let nextToken = EndUseList.data.listArEndUsers.nextToken;
        while (nextToken !== null) {
          let InvDataSec = await API.graphql(
            graphqlOperation(listArEndUsers, {
              limit: 10000,
              nextToken: nextToken,
                })
              );
          if (InvDataSec.data.listArEndUsers !== null) {
            nextToken = InvDataSec.data.listArEndUsers.nextToken;
            for (
              let i = 0;
              i < InvDataSec.data.listArEndUsers.items.length;
              i++
            ) {
              EndUserInfoLIst.push(InvDataSec.data.listArEndUsers.items[i]);
            }
          }
        }
      }
    }
        let arr = []
        if(userAuths === "1"){
          arr = multiSort(EndUserInfoLIst,sortByName1);
        }else{
          arr = multiSort(EndUserInfoLIst,sortByOrderRecipientName,sortByName1);
        }
        setEndUserList(arr);
      for (let i = 0; i < EndUserInfoLIst.length; i++) {
        if (EndUserInfoLIst[i].EndUserCode) {
            EUARBmgmtCodeList.push(EndUserInfoLIst[i].EndUserCode + ":" + EndUserInfoLIst[i].Name1)
            OrderReceiptCodeList.push(EndUserInfoLIst[i].OrderRecipientCode + ":" + EndUserInfoLIst[i].OrderRecipientName)
          }
      }
  } catch (err) {
    console.log(err);
  }
    setOrderReceiptCodeList(Array.from(new Set(OrderReceiptCodeList)))
    setEUARBmgmtCodeList(Array.from(new Set(EUARBmgmtCodeList)))
    setProgress(false);
    const handleResize = () => {
      let dom = document.querySelector("#table");
      const newZoomLevel = calculateZoomLevel();
      if (lastZoomLevel !== newZoomLevel) {
        if (newZoomLevel > lastZoomLevel) {
          setscrollTableWidth(dom ? `101%` : `101%`)
        }else {
          let width = dom ? (`${dom.offsetWidth}` < 1632 ? `1632px` : '101%') : '101%';
          setscrollTableWidth(`${width}`)
        }
        lastZoomLevel = newZoomLevel;
      }
    };
    window.addEventListener('resize',handleResize, 100);
    return () => window.removeEventListener('resize', handleResize);
    }
    getEndUserList();
  }, []);
  const headerStyle = {
    backgroundColor: "white",
    borderBottom: "3px solid #B45210",
  };
  let columns1 = [
    { dataField: "id", text: "ID", hidden: true },
    { dataField: "OrderRecipientCode", text: "受注先", hidden: authDisplay ? true : false,sort:true,headerStyle,style: { margin: "0px", width: "130px" } },
    { dataField: "OrderRecipientName", text: "名称 (受注先)",hidden: authDisplay ? true : false, sort:true,headerStyle, style: { margin: "0px", width: "130px" }, },
    {
      dataField: "EndUserCode",
      text: "エンドユーザーコード",
      headerStyle,
      sort:true,
      style: { margin: "0px", width: "130px" },
    },
    {
      dataField: "Name1",
      text: "エンドユーザ略称",
      headerStyle,
      sort:true,
      style: { margin: "0px", width: "130px" },
    },
    {
      dataField: "Name2",
      text: "エンドユーザ正式名称",
      headerStyle,
      sort:true,
      style: { margin: "0px", width: "130px" },
    },
    {
      dataField: "Name3",
      text: "名称2",
      headerStyle,
      sort:true,
      style: { margin: "0px", width: "130px" },
    },
    {
      dataField: "Name4",
      text: "名称3",
      headerStyle,
      sort:true,
      style: { margin: "0px", width: "130px" },
    },
    {
      dataField: "SearchTerm",
      text: "検索語句",
      headerStyle,
      sort:true,
      style: { margin: "0px", width: "130px" },
    },
  ];
  return (
    <Container
      style={{ backgroundColor: "", minWidth: "100%", minHeight: "74vh" }}
    >
      <Grid>
        <Grid>
          <Row
          style={{
            borderRadius: "0.25em",
            color: "purple",
            padding: "0.5em",
          }}>
            <div style={{ display: 'flex', marginBottom: "10px",width:"100%" }}>
                <Col>
                    <h4
                      style={{
                        textAlign: "left",
                        color: "black",
                        height: 30,
                        width: '20%',
                        borderLeft: "4px solid #804F29",
                        paddingLeft: "4px",
                        whiteSpace:"nowrap"
                      }}>
                      エンドユーザー一覧
                    </h4>
                </Col>
                    <div style={{ width: '80%', height: 140 }}>
                      <div style={{ width: '90%',minWidth:"500px",height: 140, border: '2px solid rgb(191,191,191)', display:authDisplay === false ? "flex" : 'none', flexWrap: "wrap",justifyContent:"center", padding: "30px 0px 0px 0px" }}>
                          <div style={{ width: "50%", height: '25px' }}>
                              <InputGroup className="mb-3" style={{ width: "100%", display: 'flex', flexWrap: "nowrap", }}>
                                <InputGroup.Text
                                    className={classes.textlabel}
                                    id="basic-name"
                                    style={{ borderRadius: "0px",minWidth:"100px"}}
                                >受注先
                                </InputGroup.Text>
                                  <Autocomplete
                                    className={classes.textFieldSearch}
                                    sx={{
                                        display: 'inline-block',
                                        '& input': {
                                            width: 300,
                                            height: 0,
                                        },
                                    }}
                                    options={OrderReceiptCodeList}
                                    value={searchValue.OrderRecipientCode}
                                    name="OrderRecipientCode"
                                    onChange={(e, value) => { TextOrderReceiptCodeChange(e, value) }}
                                    renderInput={(params) => <TextField {...params} label="" variant="outlined" />}
                                    isOptionEqualToValue={(option, value) => option.split(":")[0] === value || option === "" || value === ""}
                                />
                              </InputGroup>
                          </div>
                          <div style={{ width: "50%", height: '25px', }}>
                              <InputGroup className="mb-3" style={{ width: "100%", display: 'flex', flexWrap: "nowrap", }}>
                                <InputGroup.Text
                                    className={classes.textlabel}
                                    id="basic-name"
                                    style={{ borderRadius: "0px",minWidth:"100px"}}
                                >エンドユーザー
                                </InputGroup.Text>
                                <Autocomplete
                                  className={classes.textFieldSearch}
                                  sx={{
                                      display: 'inline-block',
                                      '& input': {
                                          height: 0,
                                      },
                                  }}
                                  options={EUARBmgmtCodeList}
                                  id="EndUserCode"
                                  value={searchValue.EndUserCode}
                                  name="EndUserCode"
                                  onChange={(e, value) => { TextEUARBmgmtCodeChange(e, value) }}
                                  renderInput={(params) => <TextField {...params} label="" variant="outlined" />}
                                  isOptionEqualToValue={(option, value) => option.split(":")[0] === value || option === "" || value === ""}
                                />
                              </InputGroup>
                          </div>
                          <div style={{margin:"auto"}}>
                              <Button className="btn" onClick={() => searchBtn()} style={{ height: 40, width: 120, fontSize: '16px', color: 'black', border: "3px solid black", background: "white",marginRight:'10px'}}>検索</Button>
                              <Button className="btn" onClick={() => searchClear()} style={{ height: 40, width: 120, fontSize: '16px', color: 'black', border: '3px solid black', background: "white"}}>Clear</Button>
                          </div>
                      </div>
                      <div style={{ width: '60%',minWidth:"60%",height: 140, border: '2px solid rgb(191,191,191)', display: authDisplay === false ? 'none' : "flex", flexWrap: "wrap",justifyContent:"center", padding: "30px 0px 0px 0px" }}>
                          <div style={{ width: "100%", height: '25px', }}>
                              <InputGroup className="mb-3" style={{ width: "100%", display: 'flex', flexWrap: "nowrap", }}>
                                <InputGroup.Text
                                    className={classes.textlabel}
                                    id="basic-name"
                                    style={{ borderRadius: "0px",minWidth:"100px"}}
                                >エンドユーザー
                                </InputGroup.Text>
                                <Autocomplete
                                  className={classes.textFieldSearch}
                                  sx={{
                                      display: 'inline-block',
                                      '& input': {
                                          height: 0,
                                      },
                                  }}
                                  options={EUARBmgmtCodeList}
                                  id="EndUserCode"
                                  value={searchValue.EndUserCode}
                                  name="EndUserCode"
                                  onChange={(e, value) => { TextEUARBmgmtCodeChange(e, value) }}
                                  renderInput={(params) => <TextField {...params} label="" variant="outlined" />}
                                  isOptionEqualToValue={(option, value) => option.split(":")[0] === value || option === "" || value === ""}
                                />
                              </InputGroup>
                          </div>
                          <div style={{margin:"auto"}}>
                              <Button className="btn" onClick={() => searchBtn()} style={{ height: 40, width: 120, fontSize: '16px', color: 'black', border: "3px solid black", background: "white",marginRight:'10px'}}>検索</Button>
                              <Button className="btn" onClick={() => searchClear()} style={{ height: 40, width: 120, fontSize: '16px', color: 'black', border: '3px solid black', background: "white"}}>Clear</Button>
                          </div>
                      </div>
                    </div>
            </div>
          </Row>
        </Grid>
        <Grid>
        <div
            style={{
              width: "100%",
              height: "100%",
              overflowX: "scroll",
              transform: "scaleY(-1)",
            }}
          >
            <div
              style={{
                width: scrollTableWidth,
                height: "80vh",
                overflowY: "scroll",
                overflowX: "hidden",
                transform: "scaleY(-1)",
              }}
            >
              <div style={{ direction: "ltr" }}>
          <BootstrapTable
          id="table"
            striped={true}
            hover={true}
            wrapperClasses="boo bg-white"
            bootstrap4
            keyField="id"
            data={endUserList}
            columns={columns1}
            noDataIndication={"no results found"}
            pagination={paginationFactory(options)}
            headerClasses={classes.fixedTop}
            />
          </div>
        </div>
        </div>
        </Grid>
    </Grid>
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "55%",
          transform: "translate(-50%, -50%)",
        }}
      >
        <CircularProgress
          size="3rem"
          disableShrink
          sx={{
            color: "#3f51b5",
            margin: "auto",
            display: progress ? "block" : "none",
            marginLeft: "60px",
          }}
        />
    </div>
    </Container>
  );
};

export default EndUserList;